import { RemoteExportPendingActivitiesPerProfessionalExcel } from 'data/usecases';
import { ExportPendingActivitiesPerProfessionalExcelUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPendingActivitiesByProfessionalsExportExcel } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeExportPendingActivitiesPerProfessionalExcel =
  (): ExportPendingActivitiesPerProfessionalExcelUseCaseInterface =>
    new RemoteExportPendingActivitiesPerProfessionalExcel(
      makeApiUrlPendingActivitiesByProfessionalsExportExcel(),
      makeAxiosHttpClient(),
    );
